<fgb-page-header [pageTitle]="'games.banner.title'" [backButtonLink]="'/'"></fgb-page-header>

<fgb-banner [bannerTitle]="'games.banner.title' | translate"></fgb-banner>

<div class="container">
  <ng-container *ifScreenSize="screenType.Desktop">
    <div *ngFor="let card of gameCards" class="card">
      <div class="card-header">
        <img alt="card.title" [src]="card.image | contentAssetImage" />
      </div>
      <div class="card-body">
        <h3>{{ card.title | translate }}</h3>
        <p>{{ card.description | translate }}</p>
        <button class="btn" (click)="navigateByURL(card.route)">{{ card.buttonLabel | translate }}</button>
      </div>
    </div>
  </ng-container>

  <ng-container *ifScreenSize="screenType.Mobile">
    <div *ngFor="let card of gameCardsMobile" class="card">
      <div class="card-header">
        <img alt="card.title" [src]="card.image | contentAssetImage" />
      </div>
      <div class="card-body">
        <h3>{{ card.title | translate }}</h3>
        <p>{{ card.description | translate }}</p>
        <button class="btn" (click)="navigateByURL(card.route)">{{ card.buttonLabel | translate }}</button>
      </div>
    </div>
  </ng-container>
</div>
